'use client';

import { useEffect, useState } from 'react';

interface ExternalSvgProps {
    src: string;
    className?: string;
    color?: string;
    stroke?: string;
    size?: number;
    'aria-label'?: string;
    'aria-hidden'?: boolean;
}

export function ExternalSvg({
    src,
    className,
    color = 'currentColor',
    stroke = 'currentColor',
    size = 24,
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden = true,
}: ExternalSvgProps) {
    const [svgContent, setSvgContent] = useState<string | null>(null);

    useEffect(() => {
        async function fetchSvg() {
            try {
                if (!src.endsWith('.svg')) {
                    console.error('Invalid file type: Only .svg files are supported.');
                    return;
                }
                const response = await fetch(src);
                if (!response.ok) throw new Error(`Failed to load SVG: ${src}`);

                let svgText = await response.text();

                svgText = svgText.replace(/fill="([^"]+)"/g, (_, prev) =>
                    prev !== 'none' ? `fill="${color}"` : `fill="none"`,
                );

                svgText = svgText.replace(/stroke="([^"]+)"/g, (_, prev) =>
                    prev !== 'none' ? `stroke="${stroke || color}"` : `fill="none"`,
                );

                svgText = svgText.replace(/ width="[^"]*"/g, ` width="${size}"`);
                svgText = svgText.replace(/height="[^"]*"/g, `height="${size}"`);

                if (!/fill="/.test(svgText)) svgText = svgText.replace('<svg', `<svg fill="${color}"`);
                if (!/width="/.test(svgText)) svgText = svgText.replace('<svg', `<svg width="${size}"`);
                if (!/height="/.test(svgText)) svgText = svgText.replace('<svg', `<svg height="${size}"`);
                svgText = svgText.replace('<svg', `<svg style="width: 100%;height: 100%;"`);

                setSvgContent(svgText);
            } catch (error) {
                console.error('Error fetching SVG:', error);
            }
        }
        fetchSvg();
    }, [src, color, stroke, size]);

    if (!svgContent) return null;

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: svgContent }}
            aria-label={ariaLabel}
            aria-hidden={ariaHidden}
        />
    );
}
